import axios, { AxiosRequestConfig } from 'axios';

import { axiosWithPasetoAuth } from '@telialt/utils/src/authentication/axiosWithPasetoAuth';
import { axiosForAnonymousHudson } from '@telialt/utils/src/axios/axiosForAnonymousHudson';
import { getHybrisCSRFToken, withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { API } from './constants';
import { AcceptMarketingConsent, CreateCheckoutCart, ServiceOffersRequestParams, ServiceOffersResponse } from './model';

export const apiGetPublicServiceOffers = (segment: TeliaSegment, params?: ServiceOffersRequestParams) => {
    return axiosForAnonymousHudson.get<ServiceOffersResponse>(withParams(API.URL_PUBLIC_SERVICE_OFFERS, { segment }), {
        params,
    });
};

export const apiGetSelfServiceServiceOffers = (
    segment: TeliaSegment,
    msisdn: string,
    params?: ServiceOffersRequestParams,
) => {
    return axiosWithPasetoAuth.get<ServiceOffersResponse>(
        withParams(API.URL_SELF_SERVICE_SERVICE_OFFERS, { segment }),
        { params: { ...params, msisdn } },
    );
};

export const apiCreateCheckoutCart = (segment: TeliaSegment, data: CreateCheckoutCart) =>
    axiosWithPasetoAuth.post(withParams(API.URL_POST_CHECKOUT_CART, { segment }), data);

export const apiGetMarketingConsent = (segment: TeliaSegment) =>
    axiosWithPasetoAuth.get<boolean>(withParams(API.URL_MARKETING_CONSENT, { segment }));

export const postMarketingConsent = (segment: TeliaSegment, data: AcceptMarketingConsent) => {
    const config: AxiosRequestConfig = {
        headers: {
            CSRFToken: getHybrisCSRFToken(),
        },
    };

    return axios.post(withParams(API.URL_SAVE_MARKETING_CONSENTS, { segment }), data, config);
};
